export default "__VITE_ASSET__ni36LtvZ__"